import { render } from "./TreesSet.vue?vue&type=template&id=324c9556"
import script from "./TreesSet.vue?vue&type=script&lang=js"
export * from "./TreesSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__